import i18n from "i18next";
import * as reportJwtApi from "../api/reportJwt";
import { notify } from "./notification";

export const CLEAR_REPORT_JWT = "CLEAR_REPORT_JWT";
export const SET_REPORT_JWT = "SET_REPORT_JWT";
export const SET_REPORT_JWT_ERR = "SET_REPORT_JWT_ERR";

export function setReportJwt(newReportJwt, secretExpiresAt) {
  return { type: SET_REPORT_JWT, newReportJwt, secretExpiresAt };
}

export function clearReportJwt() {
  return { type: CLEAR_REPORT_JWT };
}

export function setReportJwtErr(err) {
  return { type: SET_REPORT_JWT_ERR, error: err };
}

export function getReportJwt({ tz, walletClientId }) {
  return async (dispatch) => {
    try {
      const reportJwt = await reportJwtApi.getReportJwt({
        tz,
        walletClientId,
      });
      const { jwt, secretExpiresAt } = reportJwt;
      dispatch(setReportJwt(jwt, secretExpiresAt));
    } catch (err) {
      dispatch(
        notify({
          type: "error",
          message: i18n.t("Error fetching JWT token"),
        })
      );
      dispatch(setReportJwtErr(err.response?.data || err));
    }
  };
}
